<template>
    <div>
        <!-- BEGIN login -->
        <div class="login login-v2 fw-bold">
            <!-- BEGIN login-cover -->
            <div class="login-cover">
                <div
                    class="login-cover-img"
                    v-bind:style="{
                        backgroundImage: 'url(' + bg.activeImg + ')'
                    }"
                ></div>
                <div class="login-cover-bg"></div>
            </div>
            <!-- END login-cover -->

            <!-- BEGIN login-container -->
            <div class="login-container">
                <!-- BEGIN login-header -->
                <div class="login-header">
                    <div class="brand">
                        <div class="d-flex align-items-center tw-whitespaces-nowrap">
                            <span class="logo"></span> <b>FAST</b>&nbsp; FUND
                        </div>
                        <small>Fast fund is a platform for managing loans.</small>
                    </div>
                    <div class="icon">
                        <i class="fa fa-lock"></i>
                    </div>
                </div>
                <!-- END login-header -->

                <!-- BEGIN login-content -->
                <div class="login-content">
                    <div
                    class="alert alert-danger fade show ts-mb-4"
                    v-show="errorMessage != ''"
                >
                    {{ errorMessage }}
                </div>
                    <form class="fs-13px" @submit.prevent="login">
                        <div class="form-floating mb-20px">
                            <input
                                v-model.trim="model.username"
                                type="text"
                                class="form-control h-45px fs-13px"
                                placeholder="Email Address"
                                id="username"
                                :class="{
                                    'is-invalid': errors.has('username')
                                }"
                                ref="username"
                            />
                            <label
                                for="username"
                                class="d-flex align-items-center fs-13px text-gray-600"
                                >Username</label
                            >
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('username')"
                            >
                                {{ errors.first("username") }}
                            </div>
                        </div>
                        <div class="form-floating mb-20px">
                            <input
                                v-model="model.password"
                                :type="showPassword ? 'text' : 'password'"
                                class="form-control h-45px fs-13px"
                                placeholder="Password"
                                id="password"
                                :class="{
                                    'is-invalid': errors.has('password')
                                }"
                            />
                            <label
                                for="password"
                                class="d-flex align-items-center fs-13px text-gray-600"
                                >Password</label
                            >
                            <span
                                class="password-toggle"
                                @click="togglePassword"
                            >
                                <i
                                    :class="
                                        showPassword
                                            ? 'fas fa-eye-slash'
                                            : 'fas fa-eye'
                                    "
                                ></i>
                            </span>
                            <div
                                class="invalid-feedback"
                                v-if="errors.has('password')"
                            >
                                {{ errors.first("password") }}
                            </div>
                        </div>
                        <div class="mb-15px">

                            <ts-button
                                type="submit"
                                class="d-block h-45px w-100 btn-lg fs-14px"
                                :waiting="loggingIn"
                                color="warning"
                            >
                                Login</ts-button
                            >
                        </div>
                        <hr class="bg-gray-600 opacity-2" />
                        <div
                            class="text-gray-600 text-center text-gray-500-darker mb-0"
                        >
                            &copy; 2025 FAST FUND. All rights reserved.
                        </div>
                    </form>
                </div>
                <!-- END login-content -->
            </div>
            <!-- END login-container -->
        </div>
        <!-- END login -->

        <!-- begin login-bg -->
        <ul class="login-bg-list clearfix">
            <li
                v-bind:class="{ active: bg.bg1.active }"
                class="login-bg-list-item"
            >
                <a
                    href="javascript:;"
                    v-on:click="select('bg1')"
                    v-bind:style="{
                        backgroundImage: 'url(' + bg.bg1.img + ')'
                    }"
                    class="login-bg-list-link"
                ></a>
            </li>
            <li
                v-bind:class="{ active: bg.bg2.active }"
                class="login-bg-list-item"
            >
                <a
                    href="javascript:;"
                    v-on:click="select('bg2')"
                    v-bind:style="{
                        backgroundImage: 'url(' + bg.bg2.img + ')'
                    }"
                    class="login-bg-list-link"
                ></a>
            </li>
            <li
                v-bind:class="{ active: bg.bg3.active }"
                class="login-bg-list-item"
            >
                <a
                    href="javascript:;"
                    v-on:click="select('bg3')"
                    v-bind:style="{
                        backgroundImage: 'url(' + bg.bg3.img + ')'
                    }"
                    class="login-bg-list-link"
                ></a>
            </li>
            <li
                v-bind:class="{ active: bg.bg4.active }"
                class="login-bg-list-item"
            >
                <a
                    href="javascript:;"
                    v-on:click="select('bg4')"
                    v-bind:style="{
                        backgroundImage: 'url(' + bg.bg4.img + ')'
                    }"
                    class="login-bg-list-link"
                ></a>
            </li>
            <li
                v-bind:class="{ active: bg.bg5.active }"
                class="login-bg-list-item"
            >
                <a
                    href="javascript:;"
                    v-on:click="select('bg5')"
                    v-bind:style="{
                        backgroundImage: 'url(' + bg.bg5.img + ')'
                    }"
                    class="login-bg-list-link"
                ></a>
            </li>
            <li
                v-bind:class="{ active: bg.bg6.active }"
                class="login-bg-list-item"
            >
                <a
                    href="javascript:;"
                    v-on:click="select('bg6')"
                    v-bind:style="{
                        backgroundImage: 'url(' + bg.bg6.img + ')'
                    }"
                    class="login-bg-list-link"
                ></a>
            </li>
            <li
                v-bind:class="{ active: bg.bg7.active }"
                class="login-bg-list-item"
            >
                <a
                    href="javascript:;"
                    v-on:click="select('bg7')"
                    v-bind:style="{
                        backgroundImage: 'url(' + bg.bg7.img + ')'
                    }"
                    class="login-bg-list-link"
                ></a>
            </li>
            <li
                v-bind:class="{ active: bg.bg8.active }"
                class="login-bg-list-item"
            >
                <a
                    href="javascript:;"
                    v-on:click="select('bg8')"
                    v-bind:style="{
                        backgroundImage: 'url(' + bg.bg8.img + ')'
                    }"
                    class="login-bg-list-link"
                ></a>
            </li>
            <li
                v-bind:class="{ active: bg.bg9.active }"
                class="login-bg-list-item"
            >
                <a
                    href="javascript:;"
                    v-on:click="select('bg9')"
                    v-bind:style="{
                        backgroundImage: 'url(' + bg.bg9.img + ')'
                    }"
                    class="login-bg-list-link"
                ></a>
            </li>
            <li
                v-bind:class="{ active: bg.bg10.active }"
                class="login-bg-list-item"
            >
                <a
                    href="javascript:;"
                    v-on:click="select('bg10')"
                    v-bind:style="{
                        backgroundImage: 'url(' + bg.bg10.img + ')'
                    }"
                    class="login-bg-list-link"
                ></a>
            </li>
        </ul>
        <!-- end login-bg -->
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { Errors } from "form-backend-validation";
import AppOptions from "../config/AppOptions.vue";
import api from "@/api/login-api";

import Vue from "vue";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

export default {
    name: "login",
    created() {
        AppOptions.appEmpty = true;
    },
    beforeRouteLeave(to, from, next) {
        AppOptions.appEmpty = false;
        next();
    },
    data() {
        return {
            errors: new Errors(),
            errorMessage: "",
            loggingIn: false,
            app_store_url: null,
            apk_file_url: null,
            model: {
                guard: "admin",
                username: null,
                password: null
            },
            showPassword: false,
            bg: {
                activeImg: require("@/assets/img/login-bg/login-bg-1.jpg"),
                bg1: {
                    active: false,
                    img: require("@/assets/img/login-bg/login-bg-1.jpg")
                },
                bg2: {
                    active: false,
                    img: require("@/assets/img/login-bg/login-bg-2.jpg")
                },
                bg3: {
                    active: false,
                    img: require("@/assets/img/login-bg/login-bg-3.jpg")
                },
                bg4: {
                    active: false,
                    img: require("@/assets/img/login-bg/login-bg-4.jpg")
                },
                bg5: {
                    active: false,
                    img: require("@/assets/img/login-bg/login-bg-5.jpg")
                },
                bg6: {
                    active: false,
                    img: require("@/assets/img/login-bg/login-bg-6.jpg")
                },
                bg7: {
                    active: false,
                    img: require("@/assets/img/login-bg/login-bg-7.jpg")
                },
                bg8: {
                    active: false,
                    img: require("@/assets/img/login-bg/login-bg-8.jpg")
                },
                bg9: {
                    active: false,
                    img: require("@/assets/img/login-bg/login-bg-9.jpg")
                },
                bg10: {
                    active: true,
                    img: require("@/assets/img/login-bg/login-bg-10.jpg")
                }
            }
        };
    },
    mounted() {
        this.$refs.username.focus();
        this.fetchResource();
        this.randomBg()
    },
    methods: {
        ...mapActions("auth/user", ["getCurrentUser", "getAppUrl"]),
        login() {
            this.loggingIn = true;
            this.errors = new Errors();
            this.errorMessage = "";
            api.login(this.model)
                .then(async response => {
                    this.$cookies
                        .set("token", response.data.access_token, "Session")
                        .set(
                            "refresh_token",
                            response.data.refresh_token,
                            "Session"
                        );
                    this.$store.commit("setIsLock", false);

                    await this.fetchUser();
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.errorMessage = error.message;
                    this.loggingIn = false;
                });
        },
        async fetchUser() {
            await this.getCurrentUser()
                .then(async response => {
                    localStorage.setItem(
                        "authUser",
                        JSON.stringify(response.data)
                    );
                    this.$store.commit("setAuthUser", response.data);

                    this.$nextTick(() => {
                        AppOptions.pageEmpty = false;
                        this.$forceUpdate();
                    });
                    await this.$router.go(
                        this.$route.query.redirectTo || { name: "home" }
                    );
                })
                .catch(error => {
                    this.errorMessage = error.message;
                    this.loggingIn = false;
                });
        },
        async fetchResource() {
            this.getAppUrl().then(response => {
                this.apk_file_url = response.apk_file_url;
                this.app_store_url = response.app_store_url;
            });
        },
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
        select: function(x) {
            this.bg.bg1.active = false;
            this.bg.bg2.active = false;
            this.bg.bg3.active = false;
            this.bg.bg4.active = false;
            this.bg.bg5.active = false;
            this.bg.bg6.active = false;
            this.bg.bg7.active = false;
            this.bg.bg8.active = false;
            this.bg.bg9.active = false;
            this.bg.bg10.active = false;

            this.$refs.username.focus();

            switch (x) {
                case "bg1":
                    this.bg.bg1.active = true;
                    this.bg.activeImg = this.bg.bg1.img;
                    break;
                case "bg2":
                    this.bg.bg2.active = true;
                    this.bg.activeImg = this.bg.bg2.img;
                    break;
                case "bg3":
                    this.bg.bg3.active = true;
                    this.bg.activeImg = this.bg.bg3.img;
                    break;
                case "bg4":
                    this.bg.bg4.active = true;
                    this.bg.activeImg = this.bg.bg4.img;
                    break;
                case "bg5":
                    this.bg.bg5.active = true;
                    this.bg.activeImg = this.bg.bg5.img;
                    break;
                case "bg6":
                    this.bg.bg6.active = true;
                    this.bg.activeImg = this.bg.bg6.img;
                    break;
                case "bg7":
                    this.bg.bg7.active = true;
                    this.bg.activeImg = this.bg.bg7.img;
                    break;
                case "bg8":
                    this.bg.bg8.active = true;
                    this.bg.activeImg = this.bg.bg8.img;
                    break;
                case "bg9":
                    this.bg.bg9.active = true;
                    this.bg.activeImg = this.bg.bg9.img;
                    break;
                case "bg10":
                    this.bg.bg10.active = true;
                    this.bg.activeImg = this.bg.bg10.img;
                    break;
            }
        },
        randomBg() {
            let randomBg = Math.floor(Math.random() * 10) + 1;
            this.select("bg" + randomBg);
        }
    }
};
</script>
<style scoped>
.position-relative {
  position: relative;
}
.password-toggle {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d; /* Adjust color as needed */
}
.form-control.pr-5 {
  padding-right: 2.5rem !important;
}
</style>